import React from "react";

const AwardsInfo = (props) => {
  return (
    <div className="card">
      <h3>Athletic Awards</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.athleticAwardOne && (
          <div class="datas">
            <p>Athletic Award One:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardOne}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardOne}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardTwo && (
          <div class="datas">
            <p>Athletic Award Two:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardTwo}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardTwo}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardThree && (
          <div class="datas">
            <p>Athletic Award Three:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardThree}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardThree}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardFour && (
          <div class="datas">
            <p>Athletic Award Four:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardFour}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardFour}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardFive && (
          <div class="datas">
            <p>Athletic Award Five:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardFive}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardFive}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardSix && (
          <div class="datas">
            <p>Athletic Award Six:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardSix}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardSix}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardSeven && (
          <div class="datas">
            <p>Athletic Award Seven:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardSeven}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardSeven}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardEight && (
          <div class="datas">
            <p>Athletic Award Eight:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardEight}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardEight}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardNine && (
          <div class="datas">
            <p>Athletic Award Nine:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardNine}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardNine}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.athleticAwardTen && (
          <div class="datas">
            <p>Athletic Award Ten:</p>
            <del>{props.data?.uncommonOldData?.athleticAwardTen}</del>
            <span>{props.data?.uncommonNewData?.athleticAwardTen}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AwardsInfo;
